import { useEffect, useState } from 'react'
import api from '../api/client'
import Loader from '../components/Loader'
import { ShoppingBag, Clock, Users, Receipt, DollarSign, Target, Repeat, Package } from 'lucide-react'

const money = (v) => 'R$ ' + Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
const num = (v) => Number(v || 0).toLocaleString('pt-BR')

function Card({ icon: Icon, label, value, color, t }) {
  return (
    <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
      <div className={`w-9 h-9 rounded-xl bg-gradient-to-br ${color} flex items-center justify-center shadow mb-2`}><Icon size={16} className="text-white" /></div>
      <p className="text-xl font-heading font-bold text-gray-900">{value}</p>
      <p className={`text-xs font-medium ${t} mt-0.5`}>{label}</p>
    </div>
  )
}

export default function PainelVendas() {
  const [d, setD] = useState(null)
  const [loading, setLoading] = useState(true)
  useEffect(() => { api.get('/pedidos/_painel').then((r) => setD(r.data)).catch(() => setD(null)).finally(() => setLoading(false)) }, [])

  if (loading) return <div className="flex items-center justify-center h-[60vh]"><Loader size="lg" text="Carregando painel..." /></div>
  if (!d) return <p className="text-gray-500">Não foi possível carregar.</p>

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-heading font-bold text-gray-900">Painel de Vendas</h1>
        <p className="text-sm text-gray-500 mt-0.5">Sua loja digital: vendas, clientes, comissões e produtos mais vendidos.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Card icon={ShoppingBag} label="Vendas Realizadas" value={num(d.vendas_realizadas)} color="from-emerald-400 to-teal-400" t="text-emerald-700" />
        <Card icon={Clock} label="Pedidos em Andamento" value={num(d.pedidos_andamento)} color="from-amber-400 to-orange-400" t="text-amber-700" />
        <Card icon={Users} label="Clientes Cadastrados" value={num(d.clientes_cadastrados)} color="from-indigo-400 to-violet-400" t="text-indigo-700" />
        <Card icon={Receipt} label="Ticket Médio" value={money(d.ticket_medio)} color="from-blue-400 to-cyan-400" t="text-blue-700" />
        <Card icon={DollarSign} label="Comissão Gerada" value={money(d.comissao_gerada)} color="from-emerald-400 to-teal-400" t="text-accent-700" />
        <Card icon={Target} label="PV Gerado" value={num(d.pv_gerado)} color="from-rose-400 to-pink-400" t="text-rose-700" />
        <Card icon={Repeat} label="Clientes Recorrentes" value={num(d.clientes_recorrentes)} color="from-violet-400 to-purple-400" t="text-violet-700" />
        <Card icon={DollarSign} label="Receita Total" value={money(d.receita)} color="from-amber-400 to-orange-400" t="text-primary-700" />
      </div>

      <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
        <h3 className="font-heading font-semibold text-gray-900 mb-3 flex items-center gap-2"><Package size={16} /> Produtos mais vendidos</h3>
        {(d.produtos_mais_vendidos || []).length === 0 && <p className="text-sm text-gray-400">Sem vendas ainda.</p>}
        <div className="space-y-2">
          {(d.produtos_mais_vendidos || []).map((p, i) => (
            <div key={i} className="flex items-center justify-between text-sm border-b border-gray-50 pb-1.5">
              <span className="text-gray-700">{i + 1}. {p.nome}</span>
              <span className="font-semibold text-gray-900">{num(p.qtd)} un.</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
